module.exports = __webpack_public_path__ + "static/media/16-15.ba67fc75.mp3";